import React, { useState } from 'react';
import {
  View, Text, ScrollView, TouchableOpacity,
  StyleSheet, ActivityIndicator,
} from 'react-native';
import { reservationsAPI } from '../services/api';

export default function BookingConfirmScreen({ route, navigation }) {
  const { veiculo, origem, destino, data_inicio, data_fim, dias, preco_total } = route.params;
  const [loading,  setLoading]  = useState(false);
  const [aceito,   setAceito]   = useState(false);
  const [erro,     setErro]     = useState('');
  const [sucesso,  setSucesso]  = useState(false);

  const numDias = dias || Math.max(1, Math.ceil(
    (new Date(data_fim) - new Date(data_inicio)) / (1000 * 60 * 60 * 24)
  ));
  const totalFinal = preco_total || numDias * parseFloat(veiculo.preco_diario);

  const handleConfirmar = async () => {
    setErro('');
    if (!aceito) return setErro('Aceite os termos e condições para continuar');
    setLoading(true);
    try {
      await reservationsAPI.criar({
        veiculo_id:  veiculo.veiculo_id,
        data_inicio,
        data_fim,
        origem,
        destino,
      });
      setSucesso(true);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (sucesso) {
    return (
      <View style={styles.sucessoContainer}>
        <Text style={styles.sucessoEmoji}>🎉</Text>
        <Text style={styles.sucessoTitulo}>Reserva Confirmada!</Text>
        <Text style={styles.sucessoSub}>
          {veiculo.modelo} reservado de{' '}
          {new Date(data_inicio + 'T00:00:00').toLocaleDateString('pt-BR')} a{' '}
          {new Date(data_fim + 'T00:00:00').toLocaleDateString('pt-BR')}
        </Text>
        <Text style={styles.sucessoValor}>R$ {(totalFinal * 1.1).toFixed(2)}</Text>
        <TouchableOpacity
          style={styles.btnVerReservas}
          onPress={() => navigation.navigate('Main', { screen: 'MyBookings' })}
        >
          <Text style={styles.btnVerReservasText}>Ver minhas reservas</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => navigation.navigate('Main', { screen: 'Home' })}>
          <Text style={styles.linkVoltar}>Voltar ao início</Text>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <Text style={styles.pageTitle}>Confirmar Reserva</Text>

      {/* Card do veículo */}
      <View style={styles.card}>
        <Text style={styles.sectionLabel}>🚗 Veículo</Text>
        <Text style={styles.vehicleName}>{veiculo.modelo}</Text>
        <Text style={styles.vehicleSub}>{veiculo.placa} · {veiculo.ano} · {veiculo.categoria}</Text>
      </View>

      {/* Detalhes da rota */}
      <View style={styles.card}>
        <Text style={styles.sectionLabel}>🗺️ Rota</Text>
        <View style={styles.routeRow}>
          <View style={styles.routeCity}>
            <Text style={styles.routeCityLabel}>ORIGEM</Text>
            <Text style={styles.routeCityName}>{origem}</Text>
          </View>
          <Text style={styles.routeArrow}>→</Text>
          <View style={styles.routeCity}>
            <Text style={styles.routeCityLabel}>DESTINO</Text>
            <Text style={styles.routeCityName}>{destino}</Text>
          </View>
        </View>
      </View>

      {/* Período */}
      <View style={styles.card}>
        <Text style={styles.sectionLabel}>📅 Período</Text>
        <View style={styles.dataRow}>
          <View style={styles.dataItem}>
            <Text style={styles.dataLabel}>Início</Text>
            <Text style={styles.dataValue}>
              {new Date(data_inicio + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })}
            </Text>
          </View>
          <Text style={styles.dataSep}>—</Text>
          <View style={styles.dataItem}>
            <Text style={styles.dataLabel}>Fim</Text>
            <Text style={styles.dataValue}>
              {new Date(data_fim + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })}
            </Text>
          </View>
          <View style={styles.dataItem}>
            <Text style={styles.dataLabel}>Dias</Text>
            <Text style={[styles.dataValue, { color: '#F5C518' }]}>{numDias}</Text>
          </View>
        </View>
      </View>

      {/* Resumo financeiro */}
      <View style={styles.card}>
        <Text style={styles.sectionLabel}>💰 Resumo de Cobrança</Text>

        <View style={styles.financRow}>
          <Text style={styles.financLabel}>Diária</Text>
          <Text style={styles.financValue}>R$ {parseFloat(veiculo.preco_diario).toFixed(2)}</Text>
        </View>
        <View style={styles.financRow}>
          <Text style={styles.financLabel}>Número de dias</Text>
          <Text style={styles.financValue}>{numDias}x</Text>
        </View>
        <View style={styles.financRow}>
          <Text style={styles.financLabel}>Taxa de serviço (10%)</Text>
          <Text style={styles.financValue}>R$ {(totalFinal * 0.1).toFixed(2)}</Text>
        </View>
        <View style={[styles.financRow, styles.financTotal]}>
          <Text style={styles.financTotalLabel}>TOTAL</Text>
          <Text style={styles.financTotalValue}>R$ {(totalFinal * 1.1).toFixed(2)}</Text>
        </View>

        <View style={styles.matchBanner}>
          <Text style={styles.matchBannerText}>🔗 Aceite um match P2P e economize até R$ {(totalFinal * 0.35).toFixed(2)}!</Text>
        </View>
      </View>

      {/* Termos */}
      <TouchableOpacity style={styles.termoRow} onPress={() => setAceito(!aceito)}>
        <View style={[styles.checkbox, aceito && styles.checkboxChecked]}>
          {aceito && <Text style={styles.checkmark}>✓</Text>}
        </View>
        <Text style={styles.termoText}>
          Li e aceito os termos e condições de uso da plataforma YBR, incluindo a política de cancelamento e responsabilidade pelo veículo.
        </Text>
      </TouchableOpacity>

      {!!erro && <Text style={styles.erro}>{erro}</Text>}

      <TouchableOpacity
        style={[styles.btnConfirm, (!aceito || loading) && styles.btnDisabled]}
        onPress={handleConfirmar}
        disabled={!aceito || loading}
      >
        {loading
          ? <ActivityIndicator color="#1a1a1a" />
          : <Text style={styles.btnConfirmText}>Confirmar Reserva</Text>
        }
      </TouchableOpacity>

      <TouchableOpacity style={styles.btnCancel} onPress={() => navigation.goBack()}>
        <Text style={styles.btnCancelText}>Voltar</Text>
      </TouchableOpacity>

      <View style={{ height: 40 }} />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container:       { flex: 1, backgroundColor: '#f9f9f9', paddingHorizontal: 16, paddingTop: 16 },
  pageTitle:       { fontSize: 24, fontWeight: '900', color: '#1a1a1a', marginBottom: 16 },
  card:            { backgroundColor: '#fff', borderRadius: 16, padding: 18, marginBottom: 12, shadowColor: '#000', shadowOpacity: 0.06, shadowRadius: 6, elevation: 2 },
  sectionLabel:    { fontSize: 12, fontWeight: '700', color: '#aaa', letterSpacing: 1, marginBottom: 10, textTransform: 'uppercase' },
  vehicleName:     { fontSize: 22, fontWeight: 'bold', color: '#1a1a1a' },
  vehicleSub:      { fontSize: 14, color: '#888', marginTop: 4 },
  routeRow:        { flexDirection: 'row', alignItems: 'center', gap: 12 },
  routeCity:       { flex: 1, backgroundColor: '#f5f5f5', borderRadius: 10, padding: 12, alignItems: 'center' },
  routeCityLabel:  { fontSize: 10, color: '#aaa', fontWeight: '700', letterSpacing: 1 },
  routeCityName:   { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a', marginTop: 2 },
  routeArrow:      { fontSize: 24, color: '#F5C518' },
  dataRow:         { flexDirection: 'row', alignItems: 'center', gap: 8 },
  dataItem:        { flex: 1, alignItems: 'center' },
  dataLabel:       { fontSize: 11, color: '#aaa', fontWeight: '600' },
  dataValue:       { fontSize: 14, fontWeight: 'bold', color: '#1a1a1a', marginTop: 4, textAlign: 'center' },
  dataSep:         { color: '#ddd', fontSize: 18 },
  financRow:       { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 8, borderBottomWidth: 1, borderBottomColor: '#f0f0f0' },
  financLabel:     { fontSize: 14, color: '#666' },
  financValue:     { fontSize: 14, fontWeight: '600', color: '#1a1a1a' },
  financTotal:     { borderBottomWidth: 0, marginTop: 6 },
  financTotalLabel:{ fontSize: 16, fontWeight: 'bold', color: '#1a1a1a' },
  financTotalValue:{ fontSize: 22, fontWeight: '900', color: '#F5C518' },
  matchBanner:     { backgroundColor: '#fff3c4', borderRadius: 10, padding: 12, marginTop: 12 },
  matchBannerText: { fontSize: 13, color: '#7a5a00', fontWeight: '600', textAlign: 'center' },
  termoRow:        { flexDirection: 'row', gap: 12, padding: 16, backgroundColor: '#fff', borderRadius: 12, marginBottom: 16, alignItems: 'flex-start' },
  checkbox:        { width: 24, height: 24, borderRadius: 6, borderWidth: 2, borderColor: '#ddd', alignItems: 'center', justifyContent: 'center', marginTop: 2 },
  checkboxChecked: { backgroundColor: '#F5C518', borderColor: '#F5C518' },
  checkmark:       { fontSize: 14, fontWeight: 'bold', color: '#1a1a1a' },
  termoText:       { flex: 1, fontSize: 13, color: '#666', lineHeight: 20 },
  btnConfirm:      { backgroundColor: '#F5C518', borderRadius: 14, paddingVertical: 16, alignItems: 'center', marginBottom: 12 },
  btnConfirmText:  { fontSize: 17, fontWeight: 'bold', color: '#1a1a1a' },
  btnDisabled:     { opacity: 0.5 },
  btnCancel:          { alignItems: 'center', paddingVertical: 12 },
  btnCancelText:      { fontSize: 14, color: '#888', textDecorationLine: 'underline' },
  erro:               { backgroundColor: '#fdecea', color: '#c0392b', borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 14, textAlign: 'center' },
  sucessoContainer:   { flex: 1, backgroundColor: '#F5C518', alignItems: 'center', justifyContent: 'center', padding: 32 },
  sucessoEmoji:       { fontSize: 72, marginBottom: 16 },
  sucessoTitulo:      { fontSize: 28, fontWeight: '900', color: '#1a1a1a', marginBottom: 8, textAlign: 'center' },
  sucessoSub:         { fontSize: 15, color: '#444', textAlign: 'center', lineHeight: 22, marginBottom: 8 },
  sucessoValor:       { fontSize: 32, fontWeight: '900', color: '#1a1a1a', marginBottom: 32 },
  btnVerReservas:     { backgroundColor: '#1a1a1a', borderRadius: 14, paddingVertical: 16, paddingHorizontal: 40, marginBottom: 16 },
  btnVerReservasText: { fontSize: 16, fontWeight: 'bold', color: '#F5C518' },
  linkVoltar:         { fontSize: 14, color: '#555', textDecorationLine: 'underline' },
});
